import { readLocaleCookie } from 'helpers/localeCookie';
import { getLocalizationInfo } from 'project.config';

const useI18n = () => {
  const locale = readLocaleCookie();

  const config = getLocalizationInfo(locale);

  const country = config.countryCode;

  const currency = config.currency;

  const currencySymbol = config.currencyCode;

  return { country, currency, currencySymbol, locale };
};

export default useI18n;
